module.exports = __webpack_public_path__ + "static/media/logo-award-g2-leader-winter-2023.baf63623.png";